import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/staticData";

export default function Testimonials() {
  return (
    <section className="py-24 sm:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-4">Why teams stay</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Built for the agencies running real client campaigns.</h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="card-soft p-6 flex flex-col justify-between"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={20} className="text-terra mb-4" />
              <blockquote className="font-display text-lg leading-snug text-ink">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-line">
                <div className="font-medium text-sm">{t.name}</div>
                <div className="text-xs text-inkSoft">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
